// extracted by mini-css-extract-plugin
export default {"errorInput":"CommonInput_errorInput__SC-kb","tokenInput":"CommonInput_tokenInput__ksae+","tokenIcon":"CommonInput_tokenIcon__l8bhi"};